export enum EMAIL_STATUS {
  IDLE = 'idle',
  CHECKING = 'checking',
  AVAILABLE = 'available',
  TAKEN = 'taken',
}
